export const DEFAULT_SPACE_COLOR = "#abadad";
export const SPACE_ALPHA = {
  TASK: 0.2,
  EVENT: 0.3,
  TASK_HOVER_ACTIVE: 0.3,
  EVENT_HOVER_ACTIVE: 0.4,
  TASK_DONE: 0.1,
  EVENT_DONE: 0.15,
  TASK_DONE_HOVER_ACTIVE: 0.2,
  EVENT_DONE_HOVER_ACTIVE: 0.25,
  PENDING_RSVP: 0,
  PENDING_RSVP_HOVER_ACTIVE: 0.1,
  TENTATIVE_RSVP: 0.1,
  TENTATIVE_RSVP_HOVER_ACTIVE: 0.2,
} as const;
